import { patientNamespace } from "@/store/modules/patient";
import { PopupDescription } from "@/store/types";
import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class LegendDescription extends Vue {
  @Getter("popupDescription", patientNamespace)
  popupDescription!: PopupDescription;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("alerts", patientNamespace)
  alerts!: any;

  get activeIcons() {
    const result = [];
    const map = new Map();
    if (this.alerts != null) {
      const activeIcons = this.alerts
        .filter((f: any) => f.method >= 1)
        .map((a: any) => a.icon);
      for (const item of activeIcons) {
        if (!map.has(item)) {
          map.set(item, true);
          result.push(item);
        }
      }
    }
    return result;
  }

  get descriptions() {
    const configLocation = _.get(
      this.popupDescription,
      "popupConfig.data.configLocation"
    );
    if (configLocation) {
      const config = _.get(this.config, configLocation);
      const result = config.filter((a: any) =>
        this.activeIcons.some(s => s === a.icon)
      );
      return result;
    } else {
      return null;
    }
  }
}
